import { OnboardingLayout } from "~/v2/components/OnboardingLayout";
import { AssetAddressForm } from "./AssetAddressForm/AssetAddressForm.connector";
import { TravelRuleForm } from "./TravelRuleForm/TravelRuleForm.connector";
import type { WhitelistAddressControllerReturn } from "./WhitelistAddress.controller";

export const WhitelistAddressPresentation = ({
  step,
  stepConfig,
  isEditMode,
  isLoading,
  chainOptions,
  assetOptionsByChain,
  chainNameByCode,
  accountId,
  accountDetails,
  cryptoWalletAxiosInstance,
  mode,
  assetAddressData,
  assetAddressDisplay,
  travelRuleInitialValues,
  onAssetAddressNext,
  onCancel,
  onSuccess,
  onBackToAssetAddress,
}: WhitelistAddressControllerReturn) => (
  <OnboardingLayout
    isLoading={isLoading}
    onCancel={onCancel}
    title={stepConfig.title}
    description={stepConfig.description}
    currentStep={isEditMode ? 1 : stepConfig.stepNumber}
    totalSteps={isEditMode ? 1 : 2}
  >
    {step === "assetAddress" && (
      <AssetAddressForm
        chainOptions={chainOptions}
        assetOptionsByChain={assetOptionsByChain}
        chainNameByCode={chainNameByCode}
        onNext={onAssetAddressNext}
        initialValues={assetAddressData.chain ? assetAddressData : undefined}
        onCancel={onCancel}
      />
    )}
    {step === "travelRule" && (
      <TravelRuleForm
        cryptoWalletAxiosInstance={cryptoWalletAxiosInstance}
        accountId={accountId}
        assetAddressData={assetAddressData}
        assetAddressDisplay={assetAddressDisplay}
        mode={mode}
        accountDetails={accountDetails}
        onSuccess={onSuccess}
        initialValues={travelRuleInitialValues}
        onBack={isEditMode ? undefined : onBackToAssetAddress}
      />
    )}
  </OnboardingLayout>
);
